import type {Location} from 'react-router';

import {queryModule} from 'common/report/report-manager/query';

import {MetricsRequest, MetricsResponse} from './types';
import {TrackingEvent} from './tracking';

export async function fetchMetricData(
  {params, queryParams}: MetricsRequest,
  {
    abortSignal,
    location,
    trackingProps = {},
  }: {abortSignal: AbortSignal; location: Location; trackingProps?: Record<string, any>},
): Promise<MetricsResponse> {
  const startTime = Date.now();
  const res = await queryModule.executeReportQuery({
    endpoint: `metrics`,
    queryParams,
    body: {params},
    location,
    abortSignal,
  });
  const resJson = res.json();
  mixpanel.track(TrackingEvent.FetchMetricData, {
    ...trackingProps,
    metric_params: params,
    metric_response: resJson,
    [`Latency ms`]: Date.now() - startTime,
  });
  return resJson;
}
